(function() {
	'use strict';

	angular.module('claimsApp').controller(
			'ClaimRegistrationHistoryController',
			ClaimRegistrationHistoryController);

	ClaimRegistrationHistoryController.$inject = [ '$scope', '$state', '$log',
			'$resource', 'NgTableParams', 'ClaimRegistration',
			'authExpiredInterceptor', '$timeout', '$window', '$base64',
			'$stateParams', '$filter', 'FORMAT_DATE', 'GLOBAL_URL',
			'CommonService', '$uibModal' ];

	function ClaimRegistrationHistoryController($scope, $state, $log,
			$resource, NgTableParams, ClaimRegistration,
			authExpiredInterceptor, $timeout, $window, $base64, $stateParams,
			$filter, FORMAT_DATE, GLOBAL_URL, CommonService, $uibModal) {

		// init all data
		var claimRegistrationHistoryCtr = this;
		claimRegistrationHistoryCtr.policyIsTPDAndRO1 = false;
		claimRegistrationHistoryCtr.paymentMethods = [];

		claimRegistrationHistoryCtr.claimCase = {

		};

		claimRegistrationHistoryCtr.init = function() {
			ClaimRegistration.getClaimPayMethod({}, function(result) {
				claimRegistrationHistoryCtr.paymentMethods = result;
			});
			CommonService.query({
				masterurl : 'get-all-bank-las'
			}, function(result) {
				claimRegistrationHistoryCtr.bankList = result;
			});
			if ($stateParams.txnId) {
				var txnId = $base64.decode($stateParams.txnId);
				ClaimRegistration
						.getHistory(
								{
									txnId : txnId
								},
								function(result) {
									claimRegistrationHistoryCtr.claimCase = result;
									claimRegistrationHistoryCtr.getBranchBank();
									claimRegistrationHistoryCtr.docParams = new NgTableParams(
											{},
											{
												dataset : claimRegistrationHistoryCtr.claimCase.docList
											});
									claimRegistrationHistoryCtr.taskInstanceParams = new NgTableParams(
											{},
											{
												dataset : claimRegistrationHistoryCtr.claimCase.histories
											});
									claimRegistrationHistoryCtr.ackLettersParams = new NgTableParams(
											{},
											{
												dataset : claimRegistrationHistoryCtr.claimCase.ackLetters
											});
									if (result.claimType == 'TPD'
											&& result.poType == 'RO1') {
										claimRegistrationHistoryCtr.policyIsTPDAndRO1 = true;
									}
									if (claimRegistrationHistoryCtr.claimCase.poNum != null
											&& claimRegistrationHistoryCtr.claimCase.poNum != '') {
										ClaimRegistration
												.getClaimPolicyMethod(
														{
															poNum : claimRegistrationHistoryCtr.claimCase.poNum
														},
														function(result) {
															claimRegistrationHistoryCtr.policyList = result;
														});
									}

									if (claimRegistrationHistoryCtr.bankList != null
											&& claimRegistrationHistoryCtr.bankList.length > 0) {
										var isNotDiffBank = false;
										for (var i = 0, length = claimRegistrationHistoryCtr.bankList.length; i < length; i++) {
											if (claimRegistrationHistoryCtr.bankList[i].code == claimRegistrationHistoryCtr.claimCase.bankCode) {
												isNotDiffBank = true;
											}
										}
									}
								})
			}
		}

		claimRegistrationHistoryCtr.agentInfo = function() {
			if (claimRegistrationHistoryCtr.claimCase
					&& claimRegistrationHistoryCtr.claimCase.agent) {
				return claimRegistrationHistoryCtr.claimCase.agent.agentCode
						+ " - "
						+ claimRegistrationHistoryCtr.claimCase.agent.agentName;
			}
		}

		claimRegistrationHistoryCtr.la = function() {
			if (claimRegistrationHistoryCtr.claimCase
					&& claimRegistrationHistoryCtr.claimCase.la) {
				return claimRegistrationHistoryCtr.claimCase.la.clientNum
						+ " - "
						+ claimRegistrationHistoryCtr.claimCase.la.clientName;
			}
		}

		claimRegistrationHistoryCtr.reason = function() {
			if (claimRegistrationHistoryCtr.claimCase
					&& claimRegistrationHistoryCtr.claimCase.reason) {
				return claimRegistrationHistoryCtr.claimCase.reason.claimReasonCode
						+ " - "
						+ claimRegistrationHistoryCtr.claimCase.reason.claimReasonName;
			}
		}

		claimRegistrationHistoryCtr.hospital = function() {
			if (claimRegistrationHistoryCtr.claimCase
					&& claimRegistrationHistoryCtr.claimCase.hospital) {
				return claimRegistrationHistoryCtr.claimCase.hospital.hospitalCode
						+ " - "
						+ claimRegistrationHistoryCtr.claimCase.hospital.hospitalName;
			}
		}

		claimRegistrationHistoryCtr.surgery = function() {
			if (claimRegistrationHistoryCtr.claimCase
					&& claimRegistrationHistoryCtr.claimCase.surgery) {
				return claimRegistrationHistoryCtr.claimCase.surgery.surgeryCode
						+ " - "
						+ claimRegistrationHistoryCtr.claimCase.surgery.surgeryName;
			}
		}

		claimRegistrationHistoryCtr.docParams = new NgTableParams({}, {
			dataset : claimRegistrationHistoryCtr.claimCase.docList
		});
		claimRegistrationHistoryCtr.taskInstanceParams = new NgTableParams({},
				{
					dataset : claimRegistrationHistoryCtr.claimCase.histories
				});

		claimRegistrationHistoryCtr.ackLettersParams = new NgTableParams({}, {
			dataset : claimRegistrationHistoryCtr.claimCase.ackLetters
		});

		$scope
				.$watch(
						'claimRegistrationHistoryCtr.claimCase.registerDate',
						function(formattedDate) {
							claimRegistrationHistoryCtr.claimCase.registerDateStr = $filter(
									'date')(formattedDate, FORMAT_DATE);
						});

		$scope
				.$watch(
						'claimRegistrationHistoryCtr.claimCase.docCompletedDate',
						function(formattedDate) {
							claimRegistrationHistoryCtr.claimCase.docCompletedDateStr = $filter(
									'date')(formattedDate, FORMAT_DATE);
						});

		$scope
				.$watch(
						'claimRegistrationHistoryCtr.claimCase.eventDate',
						function(formattedDate) {
							claimRegistrationHistoryCtr.claimCase.eventDateStr = $filter(
									'date')(formattedDate, FORMAT_DATE);
						});

		$scope
				.$watch(
						'claimRegistrationHistoryCtr.claimCase.hopitalStartDate',
						function(formattedDate) {
							claimRegistrationHistoryCtr.claimCase.hopitalStartDateStr = $filter(
									'date')(formattedDate, FORMAT_DATE);
						});

		$scope
				.$watch(
						'claimRegistrationHistoryCtr.claimCase.hopitalEndDate',
						function(formattedDate) {
							claimRegistrationHistoryCtr.claimCase.hopitalEndDateStr = $filter(
									'date')(formattedDate, FORMAT_DATE);
						});
		$scope
		.$watch(
				'claimRegistrationHistoryCtr.claimCase.specialFromDate',
				function(formattedDate) {
					claimRegistrationHistoryCtr.claimCase.specialFromDateStr = $filter(
							'date')(formattedDate, FORMAT_DATE);
				});
		$scope
		.$watch(
				'claimRegistrationHistoryCtr.claimCase.specialToDate',
				function(formattedDate) {
					claimRegistrationHistoryCtr.claimCase.specialToDateStr = $filter(
							'date')(formattedDate, FORMAT_DATE);
				});
		claimRegistrationHistoryCtr.printLetter = function(claimAckLetterId) {
			$window.open(GLOBAL_URL + 'ga/claims/download-ack-letter/'
					+ $base64.encode(claimAckLetterId) + '?access_token='
					+ authExpiredInterceptor.getToken(), "_blank");
		}
		claimRegistrationHistoryCtr.print = function(claimCaseId) {
			$window.open(GLOBAL_URL + "ga/claims/gen-ack-letter/"
					+ $base64.encode(claimCaseId) + '?access_token='
					+ authExpiredInterceptor.getToken(), '_blank');
		}

		claimRegistrationHistoryCtr.getBranchBank = function() {
			if (claimRegistrationHistoryCtr.claimCase.bankCode != undefined
					&& claimRegistrationHistoryCtr.claimCase.bankCode != null
					&& claimRegistrationHistoryCtr.claimCase.bankCode != '') {
				CommonService
						.query(
								{
									masterurl : 'get-all-branch-las',
									bankCode : claimRegistrationHistoryCtr.claimCase.bankCode
								},
								function(result) {
									claimRegistrationHistoryCtr.branchBankList = result;
									if (claimRegistrationHistoryCtr.branchBankList != null
											&& claimRegistrationHistoryCtr.branchBankList.length > 0) {
										var isNotDiffBank = false;
										for (var i = 0, length = claimRegistrationHistoryCtr.branchBankList.length; i < length; i++) {
											if (claimRegistrationHistoryCtr.branchBankList[i].code == claimRegistrationHistoryCtr.claimCase.branchBankCode) {
												isNotDiffBank = true;
											}
										}
									}
								});
			}
		};
		
		claimRegistrationHistoryCtr.getBranchAddress = function() {
			if (claimRegistrationHistoryCtr.claimCase.branchBankCode != undefined
					&& claimRegistrationHistoryCtr.claimCase.branchBankCode != null
					&& claimRegistrationHistoryCtr.claimCase.branchBankCode != '') {
				CommonService
						.get(
								{
									masterurl : 'get-address-bank-branch',
									bankBranchCode : claimRegistrationHistoryCtr.claimCase.branchBankCode
								},
								function(result) {
									claimRegistrationHistoryCtr.claimCase.bankAddress = result.name;
								});
			}
		};
		
		claimRegistrationHistoryCtr.doPrintClaimRequestInfo = function() {
			ClaimRegistration.download({},claimRegistrationHistoryCtr.claimCase, function(result) {
				claimRegistrationHistoryCtr.afterPrint = true;
			},function(error){
				$scope.addAlert('Vui lòng nhập đủ thông tin trước khi in phiêu yêu cầu.','danger');
			});
		};
		
        claimRegistrationHistoryCtr.viewFile = function(){
        	if(claimRegistrationHistoryCtr.claimCase.txnId != undefined){
        		var id = claimRegistrationHistoryCtr.claimCase.txnId;
        		var globalUrl = GLOBAL_URL+'ga/claims/view-pdf?txnId='+id;
        		var modalInstance = 
					//show dialog
					$uibModal.open({
						animation : true,
						windowClass: 'modalLv2',
						templateUrl : GLOBAL_URL+'ga/claims/view-file?txnId='+id+'&globalUrl='+globalUrl,
						controller : 'ClaimShowFileController as claimShowFileCtrl',
						size : 'lg',
						
						resolve : {
							id : function() {
								return id;//tranfer data for dialog
							}
						}
				});
				modalInstance.result.then(
						function(result) {
							console.log(result);
						},
						function(error){
							
						});
        	}
    	}

	}
})();
